import React, { Suspense, useEffect, useState } from "react";

// routing
import { Switch, BrowserRouter, Route } from "react-router-dom";
//redux
import { useDispatch, useSelector } from "react-redux";
//types
import { UNSET_ADMIN, UPDATE_PROFILE } from "./store/admin/types";
import { startSession } from "./store/admin/action";
import { authApi } from "./util/adminAuthApi";
import { clearLegacySession, getStoredSession } from "./util/adminSession";

import { IdleTimeoutManager } from "idle-timer-manager";

import { ThemeProvider, createTheme } from "@material-ui/core";
import { blue, purple } from "@material-ui/core/colors";

//Components
import Login from "./pages/LoginPage";



import UnlockScreenPage from "./pages/UnlockScreenPage";
import Page404 from "./pages/Page404";
import Admin from "./pages/Admin";
import AuthRouter from "./util/AuthRouter";
import ConfirmCodeDialog from "./component/ConfirmCodeDialog";
import Registration from "./pages/Registration";
import UpdateCode from "./pages/UpdateCode";

const theme = createTheme({
  palette: {
    primary: {
      main: blue[700],
    },
    secondary: {
      main: purple[700],
    },
    status: {
      danger: blue[700],
    },
  },
});


function App() {
  const dispatch = useDispatch();
  const { isAuth } = useSelector((state) => state.admin);
  const [login, setLogin] = useState(false);

  // useEffect(() => {

  //   axios
  //     .get("/login")
  //     .then((res) => {
  //       console.log('res.data', res.data)
  //       setLogin(res.data.login);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

  useEffect(() => {
    // Tokens from the retired Lark login are never reused.
    clearLegacySession();
    const stored = getStoredSession();
    if (!stored) return;
    dispatch(startSession(stored.token, stored.admin));
    // Confirm the session is still valid (revoked, expired or disabled
    // sessions are rejected by the server and handled by the 401 interceptor).
    authApi
      .me()
      .then((result) => {
        if (result.status) dispatch({ type: UPDATE_PROFILE, payload: result.admin });
      })
      .catch(() => {});
  }, [dispatch]);

  useEffect(() => {
    const manager = new IdleTimeoutManager({
      timeout: 1800, //30 min (in sec)
      onExpired: (time) => {
        if (getStoredSession()) authApi.logout().catch(() => {});
        dispatch({ type: UNSET_ADMIN });
        return (window.location.href = "/");
      },
    });

    return () => {
      manager.clear();
    }; //eslint-disable-next-line
  }, []);
  return (
    <div className="App">
      <ConfirmCodeDialog />
      <Suspense fallback={""}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <Switch>
              {/* <AuthRouter exact path="/" component={login ? Login : Registration} /> */}
              <AuthRouter exact path="/" component={Login} />
              {/* <AuthRouter exact path="/code" component={UpdateCode} /> */}
              <AuthRouter exact path="/login" component={Login} />
              {/* <AuthRouter path="/Registration" component={Registration} /> */}
              <AuthRouter exact path="/unlock" component={UnlockScreenPage} />
              {isAuth && <Route path="/admin" component={Admin} />}
              <Route component={Page404} />

            </Switch>
          </BrowserRouter>
        </ThemeProvider>
      </Suspense>
    </div>
  );
}

export default App;
